<template>
    <b-card class="contenedor">
        <div slot="header"
             class="text-center font-weight-bold"
        >
            ANÁLISIS DE RIESGOS - FICHAS DE CONTROL
        </div>

        <b-row>
            <b-col>
                <label for="standard_id">
                    Estándar
                </label>
                <el-select v-model="params.standard_id"
                           id="standard_id"
                           name="standard_id"
                           filterable
                           clearable
                           size="small"
                           placeholder="Seleccione un estándar"
                           class="w-100"
                           no-data-text="No hay datos que coincidan"
                           no-match-text="No hay datos que coincidan"
                           @change="getRecommendations"
                >
                    <el-option v-for="standard in standards"
                               :key="standard.id"
                               :label="standard.nombre"
                               :value="standard.id"
                    />
                </el-select>
            </b-col>

            <b-col>
                <label for="filter">
                    Filtro
                </label>
                <el-input size="small"
                          placeholder="Buscar"
                          v-model="params.filter"
                ></el-input>
            </b-col>

            <b-col>
                <label class="w-100">
                    &nbsp;
                </label>
                <b-button variant="primary"
                          @click="getRecommendations()"
                          size="sm"
                          class="mx-1"
                >
                    <i class="fa fa-search"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Buscar'"
                    />
                </b-button>

                <b-button size="sm"
                          @click="_resetParams"
                          class="mx-1"
                >
                    <i class="fa fa-eraser"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Limpiar'"
                    />
                </b-button>

                <b-button variant="primary"
                          size="sm"
                          @click="openModalForCreation()"
                          class="float-right"
                >
                    <i class="fa fa-plus"/>
                    <span class="d-none d-md-inline-block ml-1"
                          v-text="' Crear'"
                    />
                </b-button>
            </b-col>
        </b-row>

        <b-table hover
                 striped
                 responsive
                 :fields="fields"
                 show-empty
                 empty-text="No hay recomendaciones para mostrar"
                 :items="recommendations.data"
                 class="mt-3"
        >
            <template v-slot:cell(actions)="data">
                <el-tooltip popper-class="py-1 px-2"
                            effect="dark"
                            placement="top-start"
                            content="Editar"
                >
                    <b-btn variant="primary"
                           class="mx-1"
                           size="sm"
                           @click="openModalForEdition(data.item)"
                    >
                        <i class="fa fa-edit"/>
                    </b-btn>
                </el-tooltip>
            </template>
        </b-table>

        <!-- Paginación -->
        <el-pagination v-if="recommendations.data && !!recommendations.data.length"
                       v-model="params.page"
                       @size-change="getRecommendations(true)"
                       @current-change="getRecommendations(false)"
                       :current-page.sync="params.page"
                       class="float-right"
                       :page-size.sync="params.per_page"
                       :page-sizes="[10, 30, 50, 100]"
                       layout="total, sizes, prev, pager, next"
                       :total="recommendations.total"
        />
        <modal/>
    </b-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import modal from './modal.vue';
export default {
    name: 'index',
    components: {
        modal
    },
    data() {
        return {
            fields: [
                {
                    key: 'codigo',
                    label: 'Código',
                    thStyle: 'width: 100px; min-width: 100px',
                },
                {
                    key: 'descripcion',
                    label: 'Descripción'
                },
                {
                    key: 'recommendation_type.descripcion',
                    label: 'Tipo',
                    thStyle: 'width: 200px; min-width: 200px',
                },
                {
                    key: 'estandares.0.descripcion',
                    label: 'Estándar',
                    thStyle: 'width: 200px; min-width: 200px',
                },
                {
                    key: 'actions',
                    label: 'Acciones',
                    thStyle: 'width: 120px',
                    tdClass: 'text-nowrap text-right'
                }
            ]
        };
    },
    computed: {
        ...mapState('control_sheets', [
            'standards',
            'params',
            'recommendations',
            'recommendation'
        ])
    },
    async created() {
        await this._resetParams();
        await this.getStandards();
        await this.getRecommendationTypes();
        this.load(false);
    },
    methods: {
        ...mapActions('control_sheets', [
            'getStandards',
            'getRecommendations',
            'getRecommendationById',
            'getRecommendationTypes'
        ]),
        ...mapMutations('control_sheets', [
            'setShowToModal',
            'resetParams',
            'resetRecommendation',
            'setEditing'
        ]),
        ...mapMutations('dashboard', ['load']),
        async _resetParams() {
            this.resetParams();
            await this.getRecommendations();
        },
        async openModalForCreation() {
            this.resetRecommendation();
            this.setEditing(false);
            this.setShowToModal(true);
        },
        async openModalForEdition(recommendation) {
            await this.getRecommendationById(recommendation.id);
            this.setEditing(true);
            this.setShowToModal(true);
        }
    },
};
</script>

<style
    src="../../../../node_modules/@riophae/vue-treeselect/dist/vue-treeselect.min.css"
></style>
